/*eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }]*/
import { Paginator } from '@/models/paginator'

import MyService from '@/services/my.service'
import AuthService from '@/services/auth.service'

const MAX_HISTORY = 100;
const QUERIED_HISTORY = 'QUERIED_HISTORY';
const user = AuthService.getUser();
const queriedHistory = user ? [] : JSON.parse(localStorage.getItem(QUERIED_HISTORY)) || [];
if(!user && queriedHistory.length === 0) {
  localStorage.setItem(QUERIED_HISTORY, JSON.stringify([]));
}

const initialState = {
  histories: queriedHistory,
  queries: [],
};

if(user) {
  MyService.getDefalutFormulaHistory().then( (res) => {
    initialState.histories = res.data;
  })
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async history({ rootState, commit }) {
      if(rootState.auth.user) {
        const res = await MyService.getDefalutFormulaHistory();
        commit('setHistories', res.data);
      } else {
        const histories = JSON.parse(localStorage.getItem(QUERIED_HISTORY));
        commit('setHistories', histories);
      }
    },
    addHistory({ commit }, formula) {
      commit('addHistory', formula);
    },

    async query({ rootState }, { folder, size }) {
      if(rootState.auth.user) {
        const res = await MyService.getFormula(folder.seq, new Paginator(1, size));
        return res.data;
      } else {
        const histories = JSON.parse(localStorage.getItem(QUERIED_HISTORY));
        return histories.slice(0, size);
      }
    },
    async moveQuery({ rootState, dispatch }, {targetFolder, queries}) {
      if(rootState.auth.user) {
        const res = await MyService.moveFormula(targetFolder, queries);
        await dispatch('my/history', {}, {root: true});
        return res.data;
      }
      return queries;
    },
    async deleteQuery({ rootState, dispatch }, {queries}) {
      if(rootState.auth.user) {
        if(queries.length) {
          await MyService.deleteFormula(queries);
        }
      } else {
        if(queries.length) {
          const histories = JSON.parse(localStorage.getItem(QUERIED_HISTORY));

          const h = histories.filter(
            (value) => {
              return !queries.some((q)=> {
                return (q.formula === value.formula && q.domain === value.domain)
              })
            }
          );
          localStorage.setItem(QUERIED_HISTORY, JSON.stringify(h));
        }
      }

      await dispatch('my/history', {}, {root: true});

      return queries;
    },

    async folder() {
      const res = await MyService.getFormulaFolder();
      return res.data;
    },
    async addFolder({ _commit }, folder) {
      const res = await MyService.addFolder(folder);
      return res.data;
    },
    async updateFolder({ _commit }, folder) {
      const res = await MyService.updateFolder(folder);
      return res.data;
    },
    async deleteFolder({ _commit }, folder) {
      const res = await MyService.deleteFolder(folder);
      return res.data;
    },

    async getBookmark({ _commit }, paginator) {
      const res = await MyService.getBookmark(paginator);
      return res.data;
    },
    async hasBookmark({ _commit }, content) {
      if(!content || !content.seq) {
        return false;
      }
      const res = await MyService.hasBookmark(content);
      return res.data;
    },
    async toggleBookmark({ _commit }, content) {
      const res = await MyService.toggleBookmark(content);
      return res.data;
    },

    async getApplicationMemo({ _commit }, content) {
      const res = await MyService.getApplcationMemo(content);
      return res.data;
    },
    async getMemo({ _commit }, {search, paginator}) {
      const res = await MyService.getMemo(search, paginator);
      return res.data;
    },
    async upsertMemo({ _commit }, memo) {
      const res = await MyService.upsertMemo(memo);
      return res.data;
    },
    async deleteMemo({ _commit }, memo) {
      const res = await MyService.deleteMemo(memo);
      return res.data;
    }

  },
  mutations: {
    setHistories(state, formulas) {
      state.histories = formulas;
    },
    addHistory(state, formula) {
      if(!formula.domain || !formula.formula) {
        return;
      }

      const sameHistory = state.histories.filter( h => h.domain === formula.domain && h.formula === formula.formula );

      if( sameHistory && sameHistory.length === 0 ) {
        const length = state.histories.unshift(formula);
        if(length > MAX_HISTORY) {
          state.histories.splice(-1,1)
        }
      }
      localStorage.setItem(QUERIED_HISTORY, JSON.stringify(state.histories));
    },
  }
};